
import _ from 'lodash'
export default {
    name: 'SettingTabs',
    props: {
        bodyStyle: String
    },
    data() {
        return {
            activeIndex: 0
        }
    },
    methods: {
        active(n: number) {
            this.activeIndex = n
        }
    },
    render(h, hack) {
        let childSlots = this.$slots.default
        const innerContent = _.filter(_.castArray(childSlots), (vnode) => vnode && vnode.tag)
        const tabs = _.map(innerContent, x => x.componentOptions.propsData.tabName)
        const activeIndex = this.$data.activeIndex
        const body = _.get(innerContent, activeIndex)
        return h('div', { class: 'setting-tabs' }, [
            h('div', { class: 'setting-tabls-header' }, _.map(tabs, (tabName, idx) => {
                return h('div', {
                    class: { 'setting-tabls_tab': true, 'active': idx === activeIndex }, on: {
                        'click': ev => {
                            this.$data.activeIndex = idx
                            this.$emit('active', idx)
                        }
                    }
                }, [h('div', { class: 'text' }, tabName)])
            })),
            h('div', { class: 'setting-tab-body', style: this.$props.bodyStyle }, [body])
        ])
    },
}
